export default __webpack_public_path__ + "offline.f18e45e1f79a19b6fabd64755d974212.svg";